import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import type { Language } from '../../constants/language';
import { LANGUAGE_LOCALSTORAGE_KEY } from '../../constants/localstorage';

type UseLanguageResult = [Language, (newLanguage: Language) => void];

export function useLanguage(): UseLanguageResult {
    const { i18n } = useTranslation();

    const changeLanguage = useCallback(
        async (newLanguage: Language) => {
            // Force reload of all resources for the new language
            const namespaces = [
                'translation',
                'onboarding',
                'auth',
                'subscription',
                'dashboard',
                'pattern-studio',
                'table',
                'pattern',
                'pattern-watchlist',
                'data-display',
                'profile-management',
                'trading-journal-connection',
                'trading-journal',
            ];

            // Reload all namespaces for the new language
            await Promise.all(
                namespaces.map((ns) => i18n.reloadResources(newLanguage, ns)),
            );

            await i18n.changeLanguage(newLanguage);
            localStorage.setItem(LANGUAGE_LOCALSTORAGE_KEY, newLanguage);
        },
        [i18n],
    );

    return [i18n.language as Language, changeLanguage];
}
